import { useFloatingContext } from 'library/floating';
import { ListItem } from 'library/list';
import { DetailedHTMLProps, ForwardedRef, LiHTMLAttributes, MouseEvent, forwardRef } from 'react';

interface DropdownItemProps extends DetailedHTMLProps<LiHTMLAttributes<HTMLLIElement>, HTMLLIElement> {
    ref?: ForwardedRef<HTMLLIElement>;
    hover?: boolean;
    disabled?: boolean;
}

const DropdownItem = forwardRef<HTMLLIElement, DropdownItemProps>((props, ref) => {
    const { children, hover, disabled, onClick, ...rest } = props;

    const { context } = useFloatingContext();

    const handleClick = (e: MouseEvent<HTMLLIElement>) => {
        if (disabled) return;

        if (onClick) {
            onClick?.(e);
        }

        context.onOpenChange(false);
    };

    return (
        <ListItem {...rest} ref={ref} hover={hover} disabled={disabled} onClick={handleClick}>
            {children}
        </ListItem>
    );
});

export default DropdownItem;
